// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-templates/order-templates.less
// module id = 3597
// module chunks = 0